// the values will be corresponding to keys and are case sensitive
export enum RecoveryFlowErrorKeys {
  InvalidRangeError = "invalidRange",
  InvalidRequestError = "invalidRequest",
  RangeError = "RangeError",
  ExpiredTokenError = "expiredToken",
  ProvisioningNotAllowedError = "provisioningNotAllowed",
  OneDriveQuotaLimitReachedError = "OneDriveQuotaLimitReached",
  QuotaLimitReachedError = "quotaLimitReached",
  UnableToFetchTokenError = "UnableToFetchToken",
  ResourceLockedError = "resourceLocked",
  InvalidAuthenticationToken = "InvalidAuthenticationToken",
  ConditionalAccessPolicyEnforced = "conditionalAccessPolicyEnforced"
};